module.exports = __webpack_public_path__ + "imgcvh/hero-2.6461bb8f.jpg";